<template>
  <div class="flex flex-col gap-2">
    <template v-for="segment in segments" :key="segment.id">
      <label
        class="space-x-2 transform right-slant text-white h-12 flex items-center px-6 mr-auto rounded shadow-md transition-all"
        :style="{
          backgroundColor: segment.color,
          width: `${segment.level}%`,
        }"
        :class="{
          'hover:brightness-110 cursor-pointer': !disabled,
          'opacity-90 cursor-not-allowed': disabled,
        }"
      >
        <input
          :id="segment.id"
          :value="segment.id"
          name="evidence"
          type="radio"
          class="relative size-4 appearance-none rounded-full border border-gray-300 bg-white before:absolute before:inset-1 before:rounded-full before:bg-white not-checked:before:hidden checked:border-primary-600 checked:bg-primary-600 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-600 forced-colors:appearance-auto forced-colors:before:hidden transition-opacity duration-150"
          :checked="selectedSegmentId === segment.id"
          :disabled="disabled"
          @click.stop="handleSegmentClick(segment.id)"
        />

        <div>
          <p class="font-semibold">{{ segment.label }}</p>
        </div>
      </label>
    </template>
  </div>
</template>

<script setup lang="ts">
interface Segment {
  level: number
  label: string
  color: string
  id: string
}

defineProps<{ segments: Segment[]; disabled?: boolean }>()

const selectedSegmentId = defineModel<string>()
function handleSegmentClick(id: string) {
  selectedSegmentId.value = selectedSegmentId.value === id ? '' : id
}
</script>
